module.exports = __webpack_public_path__ + "img/training.53d6812b.jpg";